module.exports = __webpack_public_path__ + "static/media/recruit_230_art.9190e6a2.png";